<template>
    <div class="py-4 container-fluid">
      <div class=" row">
        <div class="col-12">
          <ClientsTable :categories="products_category"
          @category-deleted="fetchProducts"/>
        </div>
      </div>

    </div>
</template>

<script>
import axios from "axios";
import ClientsTable from "./components/Table.vue";
const companyId = localStorage.getItem('companyId');
export default {
    name: "Products Categories",
    components: {
        ClientsTable,
    },
    data() {
        return {
            products_category:[],
        };
    },
    methods:{
        async fetchProducts(){
            let self=this;
            const token = localStorage.getItem("accessToken");
            const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'accept': '*/*',
                        'Authorization':`Bearer ${token}`
                    }
                };
            axios.get(this.$store.state.apiURL+'products_category?company='+companyId,config)
            .then((result)=>{
                console.log(result);
                this.products_category=result.data;
            })
            .catch(error => {
                console.log(error)
                self.$swal({
                    title: 'Sesión',
                    text: 'El tiempo de sesión a vencido, ingresa nuevamente.',
                    type: 'warning',
                    icon:'warning',
                    showCancelButton: false,
                    confirmButtonColor:'#bf4f51',
                    showCloseButton: true,
                    showLoaderOnConfirm: false
                }).then(function(){
                    localStorage.removeItem('user');
                    localStorage.removeItem('accessToken');
                    self.$router.push('/signin');
                });
            });
        }
    },
    mounted() {
        this.fetchProducts();
    },
};
</script>
